<template>
    <index-table-row :item="item">
        <index-table-cell v-text="item.name"/>
        <index-table-cell v-text="item.reseller"/>
        <index-table-cell-triple-state v-model="item.compliance_active"/>
        <index-table-cell-triple-state v-model="item.dfs_active"/>
        <index-table-cell-triple-state v-model="item.academy_active"/>
        <index-table-cell-date :date="String(item.created_at)"/>
        <index-table-cell>
            <organization-more-dropdown :organization="itemData"/>
        </index-table-cell>
    </index-table-row>
</template>

<script>
    import IndexTableRow from "../../components/Index/IndexTableRow";
    import IndexTableCell from "../../components/Index/IndexTableCell";
    import OrganizationMoreDropdown from "./OrganizationsMoreDropdown";
    import IndexTableCellDate from "../../components/Index/IndexTableCellDate";
    import IndexTableCellTripleState from "@/new/components/Index/IndexTableCellTripleState";

    export default {
        name: "OrganizationRow",
        components: {
            IndexTableCellTripleState, IndexTableCellDate, OrganizationMoreDropdown, IndexTableCell, IndexTableRow },
        props: {
            item: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                itemData: this.item,
            }
        },
        watch: {
            item(value) {
                this.itemData = value;
            }
        }
    }
</script>

<style lang="scss">
    .app-action {
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 27px;
        width: 80px;

        .app-action-btn {
            display: none !important;
        }

        &:hover {
            .md-icon {
                display: none;
            }

            .app-action-btn {
                display: inline-block !important;
                width: auto !important;
            }
        }
    }
</style>